import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { Button } from "ksc-portal-common-components/shadcn"
import { toast } from "sonner"
import { USER_SETTINGS_ENDPOINT, DEFAULT_HOMEPAGE_OPTION } from "../constants"
import Sidebar from "../../Sidebar"
import UserSettingsDropdown from "../components/UserSettingsDropdown"

const UserSettingsGeneral = ({
  defaultHomepageOptions,
  settings,
  patchRequest,
  storeSettings,
  history: { goBack },
  replaceSidebar,
  closeSidebar,
}) => {
  useEffect(() => {
    replaceSidebar(Sidebar)
    closeSidebar()
  }, [])
  const [homepage, setHomepage] = useState("")
  const dropdownData = [DEFAULT_HOMEPAGE_OPTION, ...defaultHomepageOptions].map(
    ({ name, path }) => ({ name, value: path })
  )

  useEffect(() => {
    if (!homepage) setHomepage(settings.homepage)
  })

  const onSubmit = () => {
    patchRequest({
      url: USER_SETTINGS_ENDPOINT,
      body: { homepage },
      onSuccess: (response) => {
        storeSettings(response)
        toast.success("Settings updated")
      },
      onFailure: () => {
        toast.error("An error occurred")
      },
    })
  }

  const getHomepageValue = () => {
    if (homepage === "/home") return DEFAULT_HOMEPAGE_OPTION

    return (
      defaultHomepageOptions.find((module) => module.path === homepage) || {}
    )
  }

  return (
    <div className="portal-user-settings-content">
      <div className="flex">
        <div className="portal-user-settings-content__first-column">
          <span className="portal-user-settings-content__label">
            Default homepage
          </span>
        </div>
        <div>
          <UserSettingsDropdown
            data={dropdownData}
            defaultValue={getHomepageValue().name}
            onChange={setHomepage}
          />
        </div>
      </div>
      <div className="flex gap-2 justify-end mt-4">
        <Button
          variant="default"
          onClick={onSubmit}
          data-testid="portal-user-settings__save-btn"
        >
          SAVE
        </Button>
        <Button
          variant="outline"
          onClick={goBack}
          data-testid="portal-user-settings__cancel-btn"
        >
          CANCEL
        </Button>
      </div>
    </div>
  )
}

UserSettingsGeneral.propTypes = {
  defaultHomepageOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string,
    })
  ),
  settings: PropTypes.shape({
    homepage: PropTypes.string,
  }),
  patchRequest: PropTypes.func.isRequired,
  storeSettings: PropTypes.func.isRequired,
  replaceSidebar: PropTypes.func.isRequired,
  closeSidebar: PropTypes.func.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
}

UserSettingsGeneral.defaultProps = {
  defaultHomepageOptions: [],
  settings: { homepage: null },
}

export default UserSettingsGeneral
